module.exports = __webpack_public_path__ + "media/images/babel-bcfddbd9cb9c12575ed65c4575920f4a.jpg";